import * as keyapis_jwks_v1_key_pb from "./v1/keyapis_jwks_key_v1.pb";
import * as keyapis_jwks_v1_system_pb from "./v1/keyapis_jwks_system_v1.pb";

export default {
  v1: {
    resources: {
      key: keyapis_jwks_v1_key_pb,
      system: keyapis_jwks_v1_system_pb,
    },
  },
};
